import React from 'react';
import './demo-button.styles.scss';

export function DemoButton() {
  return (
    <a href='https://hooklab.com.br/demonstracao'>
      <button className='demo-button'>Demonstração gratuita</button>
    </a>
  );
}